import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import tick from "../../assets/tick.svg";
import { Close } from "@material-ui/icons";

import React from "react";
import CustomModal from "./CustomModal";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "1rem",
    background: "#FFFFFF",

    boxShadow: "0px 4px 12px rgba(34, 43, 69, 0.06)",
    borderRadius: "6px",
    height: "30rem",
    width: "35rem",
  },
  close: {
    display: "flex",
    cursor: "pointer",
    marginLeft: "auto",
    marginBottom: "2rem",
  },
  btn: {
    width: "13rem",
    margin: "2rem auto 0rem auto",
    display: "flex",
  },
  poolLabelValue: {
    fontWeight: "600",
    fontSize: "1.4rem",
  },
  center: {
    textAlign: "center",
  },
  subHead: {
    fontWeight: "700",
    fontSize: "1.8rem",
    textAlign: "center",
    margin: "5rem 0rem 3rem 0rem",
  },
}));

const ManageFundsModal = ({ showModal, setShowModal, text }) => {
  const classes = useStyles();

  return (
    <CustomModal showModal={showModal} setShowModal={setShowModal}>
      <Box className={classes.container}>
        <Box>
          <Close
            onClick={() => setShowModal(false)}
            className={classes.close}
            fontSize="large"
          />
        </Box>
        <Box className={classes.center}>
          <img width="35%" src={tick} alt="protokol" />
        </Box>
        <Typography className={classes.subHead}>{text}</Typography>
        {/* <Button className={classes.btn}>
          <Typography className={classes.poolLabelValue}>Invest</Typography>
        </Button> */}
      </Box>
    </CustomModal>
  );
};

export default ManageFundsModal;
